import React, { memo } from 'react';
import { Skeleton, Tag } from 'gatorcomponents';
import useStatusFormatter from '@/hooks/useStatusFormatter';

const ServerStatus = memo(({
  loading,
  status,
  testId,
}) => {
  const statusData = useStatusFormatter(status);

  if (loading) {
    return <Skeleton width="80px" height="32px" />;
  }

  return statusData ? <Tag label={statusData.value} variant={statusData.variant} size="md" testId={testId} /> : null;
});

ServerStatus.displayName = 'ServerStatus';

export default ServerStatus;
